import React from 'react';
import PropTypes from 'prop-types';

class TrackCompletion extends React.Component {
  render() {
    const {primaryColor, color} = this.props;

    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="154"
        height="142"
        viewBox="0 0 128 119">
        <g transform="translate(1 1)" fill="none" fillRule="evenodd">
          <circle stroke={color} strokeWidth="2" cx="58.5" cy="58.5" r="58.5" />
          <g transform="translate(94 17)">
            <circle fill={primaryColor} cx="16.5" cy="16.5" r="16.5" />
            <path
              d="M22.845 10.273a1.27 1.27 0 0 0-1.773.197l-6.507 8.07-1.293-1.708a1.27 1.27 0 0 0-1.767-.25 1.242 1.242 0 0 0-.253 1.75l2.272 2.999a1.266 1.266 0 0 0 1.01.5c.383 0 .746-.173.986-.47l7.524-9.331a1.242 1.242 0 0 0-.199-1.757z"
              fill="#FFF"
              fillRule="nonzero"
            />
          </g>
          <path
            d="M73.661 44.865l.005-.087c.016-.361-.102-.71-.317-.937-.19-.198-.442-.299-.75-.299h-5.183l-.002-.232a97.35 97.35 0 0 1-.006-.937 1.33 1.33 0 0 0-.043-.326l-.01-.034.003-.035c.018-.361-.1-.712-.316-.94-.19-.198-.442-.3-.751-.3-.98 0-1.959-.004-2.937-.008h-.23l-.004-.23a20.17 20.17 0 0 0-.206-2.671c-.078-.514-.62-.821-1.101-.821h-.066l-.057-.006L57.112 37c-.34 0-.62.127-.811.369-.23.291-.314.722-.218 1.124l.016.07-.025.067a1.184 1.184 0 0 0-.079.413v1.582l-.242-.007a157.4 157.4 0 0 1-2.989-.114h-.048c-.095 0-.189.012-.295.04l-.031.01-.033-.001c-.557 0-1.14.35-1.148 1.121-.004.396-.02.79-.043 1.183l-.014.22h-.22c-1.712.005-3.543.036-5.339.23-.06.007-.113.022-.167.036l-.077.012c-.561 0-1.122.346-1.122 1.12v4.44c0 .25.062.47.185.653l.04.059v.071c-.002 9.974-.036 18.98-.45 28.2-.006.112.006.223.035.35l.011.048-.009.048c-.055.308-.006.59.14.792.132.185.338.299.614.34 9.027 1.338 17.933 1.448 27.805 1.449.714 0 .948-.544 1.015-.777l.015-.052.036-.04a1.1 1.1 0 0 0 .276-.765V45.644c0-.28-.076-.518-.226-.71l-.053-.07zM58.23 39.334h2.629l.01.223c.016.304.025.609.026.914l.002.239-.82-.009c-.54-.005-1.078-.01-1.616-.02l-.23-.004v-1.343zm-5.15 8.517c.084-.633.164-2.166.227-3.398.03-.567.055-1.062.076-1.362l.016-.228.228.01c3.897.167 7.744.194 11.32.198h.232l.002.232c.028 2.51.076 4.262.14 4.933l.026.268-.27-.011a466.925 466.925 0 0 0-6.14-.198c-1.878-.053-3.755-.105-5.633-.178l-.257-.01.033-.256zm18.628 30.738h-.235c-8.862-.006-16.861-.101-25.005-1.22l-.211-.028.009-.214c.388-9.088.42-18.153.42-28.212 0-.25-.062-.47-.185-.654l-.04-.06V45.56l.218-.016a58.397 58.397 0 0 1 3.966-.132h.268l-.034.266c-.01.082-.023.702-.033 1.2-.017.816-.027 1.212-.04 1.31-.03.216-.022.43.024.633l.01.047-.008.047c-.07.387.026.804.252 1.088.193.242.47.378.802.393 2.362.108 4.767.172 7.091.234 2.327.061 4.734.125 7.1.234l.061.001c.336 0 .555-.128.701-.287a.938.938 0 0 0 .479-.43l.027-.06a.836.836 0 0 0 .05-.148c.022-.095.032-.192.048-.287.146-.195.22-.414.193-.628-.022-.174-.039-.817-.06-1.707a43.58 43.58 0 0 0-.037-1.187l-.022-.255h4.191V78.59z"
            fillRule="nonzero"
            fill={color}
          />
          <rect
            stroke={color}
            x="52.5"
            y="59.5"
            width="13"
            height="1"
            rx=".5"
          />
          <rect
            stroke={color}
            x="52.5"
            y="63.5"
            width="13"
            height="1"
            rx=".5"
          />
          <rect
            stroke={color}
            x="52.5"
            y="67.5"
            width="13"
            height="1"
            rx=".5"
          />
        </g>
      </svg>
    );
  }
}

TrackCompletion.defaultProps = {
  primaryColor: '#aaa',
  color: '#ccc',
};

TrackCompletion.propTypes = {
  primaryColor: PropTypes.string,
  color: PropTypes.string,
};

export default TrackCompletion;
